import {useSelector} from "react-redux";

export const useUIConfig = () => {
	return useSelector((state) => {
		return state.config_ui;
	});
}